import { render, staticRenderFns } from "./Provinces.vue?vue&type=template&id=9cce8926"
import script from "./Provinces.vue?vue&type=script&lang=js"
export * from "./Provinces.vue?vue&type=script&lang=js"
import style0 from "./Provinces.vue?vue&type=style&index=0&id=9cce8926&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports